<section>
  <p class="body-header">The End</p>
  <p class="body-text">
    While machine learning algorithms have the potential to revolutionize
    decision-making, we have to ensure that a fairness criteria is used for
    measuring any potential bias in addition to general Machine Learning
    metrics. Depending on the outcome of the bias evaluation we should include
    bias mitigation. Equality of Odds (EO) offers a promising approach to
    mitigate bias and is a method that can be used in different ways (and even
    during post-processing with access only to the predictions). However, before
    using EO for evaluation or bias mitigation, we should carefully consider the
    context and potential trade-offs between competing objectives.
  </p>
</section>
